import React from 'react';
import { GiftIcon } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'Recetario Especial de Budines Salados',
    image: 'https://cdn.magicpatterns.com/uploads/fWrSuNCw9LpS5kCptS5t7g/bono_1.png',
    description: 'Aprendé a preparar budines salados perfectos para picadas, almuerzos rápidos o cenas livianas. Recetas deliciosas que combinan queso, verduras y otros ingredientes para crear budines salados increíbles.'
  }, {
    title: 'Guía de Coberturas y Glaseados para Budines',
    image: 'https://cdn.magicpatterns.com/uploads/fNMRDkw1z7jg2D6B7MAj2p/bono_2.png',
    description: 'Transformá cualquier budín simple en una receta espectacular. Aprendé a preparar glaseados, coberturas y terminaciones que hacen que cualquier budín se vea y sepa increíble.'
  }, {
    title: 'Kit para Empezar a Vender Budines Caseros',
    image: 'https://cdn.magicpatterns.com/uploads/6J65ZVSEbjBSnvsYzg3hwK/bono_3.png',
    description: 'Si querés convertir esta habilidad en un pequeño ingreso extra, este bono te muestra: Cómo calcular precios, Cómo presentar los budines, Ideas simples para vender desde casa.'
  }, {
    title: 'Tabla de Conversiones y Trucos de Repostería',
    image: 'https://cdn.magicpatterns.com/uploads/9n84b1w2G9XGH8gVrcXbGY/bono_4.png',
    description: 'Una guía rápida con conversiones, proporciones y pequeños secretos que hacen una gran diferencia en el resultado final.'
  }];
  return <section className="py-20 px-4" data-id="element-26">
      <div className="max-w-5xl mx-auto" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-[#3D2B1F]" data-id="element-29">
            Pero eso no es todo.
          </h2>
          <p className="text-xl md:text-2xl text-[#6B5344]" data-id="element-30">
            Para que puedas sacarle todavía más provecho, también vas a recibir{' '}
            <span className="text-[#D4850A] font-bold" data-id="element-31">
              4 bonos exclusivos.
            </span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-32">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white rounded-3xl overflow-hidden border border-[#E8D5C4] hover:border-[#D4850A]/50 transition-colors duration-300 flex flex-col shadow-md" data-id="element-33">
              <div className="relative group cursor-pointer" onClick={() => document.getElementById('compra')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-34">
                <div className="absolute top-4 right-4 bg-red-600 text-white text-sm font-bold px-3 py-1 rounded-full z-10 flex items-center gap-1 shadow-lg animate-pulse" data-id="element-35">
                  <GiftIcon className="w-4 h-4" data-id="element-36" />
                  GRATIS por hoy
                </div>
                <img src={bonus.image} alt={bonus.title} className="w-full h-64 object-contain bg-[#FEF3E2] p-4 transform transition-transform duration-500 group-hover:scale-105" data-id="element-37" />
              </div>
              <div className="p-8 flex-1 flex flex-col" data-id="element-38">
                <div className="text-[#D4850A] font-bold text-sm mb-2 uppercase tracking-wider" data-id="element-39">
                  Bono {index + 1}
                </div>
                <h3 className="text-2xl font-bold mb-4 text-[#3D2B1F]" data-id="element-40">
                  {bonus.title}
                </h3>
                <p className="text-[#9B8578] leading-relaxed flex-1" data-id="element-41">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}